'use client';

import { useState } from 'react';
// hooks
import { useRouter } from 'next/navigation';

// types
import Table from '@mui/material/Table';
import Modal from '@mui/material/Modal';
// @mui
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import { Box, Collapse, TableHead } from '@mui/material';

// locales
import { useTranslate } from 'src/locales';

// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

import RuleView from './profile-tule-view';
import RuleEdit from './profile-tule-edit';
import { useBoolean } from '../../../../../hooks/use-boolean';
//
// import CustomerQuickEditForm from './customer-quick-edit-form';

// ----------------------------------------------------------------------

type Props = {
  selected: boolean;
  onEditRow: VoidFunction;
  row: any;
  onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  page?: string;
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '100%', md: 600 },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export default function ProfileAffiliateRulesTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  page,
}: Props) {
  const { t } = useTranslate();

  const [open, setOpen] = useState(false);

  const { id, rule, merchant, valueType, date, status, value, invoiceNumber, assigned } = row;

  const confirm = useBoolean();

  const quickEdit = useBoolean();

  const popover = usePopover();

  const router = useRouter();

  const openDetails = useBoolean();

  const openEdit = useBoolean();

  const handleDetails = () => {
    // router.push(paths.dashboard.affiliates.affiliateRules.details(id));
  };

  return (
    <>
      <TableRow hover selected={selected} sx={{ cursor: 'pointer' }}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={() => setOpen(!open)}>
          {rule}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={() => setOpen(!open)}>
          <ListItemText
            primary={merchant}
            secondary={invoiceNumber}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{
              fontSize: 12,
              component: 'p',
              color: 'text.disabled',
            }}
          />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={() => setOpen(!open)}>
          {date}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={() => setOpen(!open)}>
          {value}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }} onClick={() => setOpen(!open)}>
          {valueType}
        </TableCell>

        <TableCell onClick={() => setOpen(!open)}>
          <Label
            variant="soft"
            color={
              (status === 'active' && 'success') ||
              (status === 'pending' && 'warning') ||
              (status === 'banned' && 'error') ||
              'default'
            }
          >
            {status}
          </Label>
        </TableCell>

        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'}>
            <Iconify icon="lsicon:view-filled" onClick={() => openDetails.onTrue()} />
          </IconButton>
          <IconButton color={popover.open ? 'inherit' : 'default'}>
            <Iconify
              icon="mynaui:circle-half-circle-solid"
              width={24}
              sx={{ transform: 'rotate(90deg)' }}
            />
          </IconButton>
          <IconButton color={popover.open ? 'inherit' : 'default'}>
            <Iconify icon="ic:baseline-share" />
          </IconButton>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  <TableCell>Assigned</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Value Type</TableCell>
                  <TableCell>Value</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ color: 'grey' }}>{assigned}</TableCell>
                  <TableCell sx={{ color: 'grey' }}>{date}</TableCell>
                  <TableCell sx={{ color: 'grey' }}>{valueType}</TableCell>
                  <TableCell sx={{ color: 'grey' }}>{value}</TableCell>
                  <TableCell sx={{ color: 'grey' }}>{status}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          {t('Delete')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            // onEditRow();
            openEdit.onTrue();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          {t('Edit')}
        </MenuItem>
      </CustomPopover>

      <Modal open={openDetails.value} onClose={openDetails.onFalse}>
        <Box sx={style}>
          <RuleView close={() => openDetails.onFalse()} />
        </Box>
      </Modal>

      <Modal open={openEdit.value} onClose={openEdit.onFalse}>
        <Box sx={style}>
          <RuleEdit close={() => openEdit.onFalse()} />
        </Box>
      </Modal>
    </>
  );
}
